import React, { useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import fingerPrintServices from "../utilities/demo"; // Import fingerprint service
import FingerprintScannerLoader from "../components/FingerprintScannerLoader";
import { toast } from "react-toastify";

const UpdateThumb = ({ handleClose }) => {
  const [loginId, setLoginId] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [userName, setUserName] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [fingerprintScannerLoading, setFingerprintScannerLoading] =
    useState(false);
  const [enteredOtp, setEnteredOtp] = useState(""); // OTP input
  const [isVerified, setIsVerified] = useState(false); // OTP verification
  const [fingerprintData, setFingerprintData] = useState("");

  const { callSGIFPGetData, successFunc1, errorFunc } = fingerPrintServices(); // Fingerprint functions

  // Fetch Mobile Number Based on Login ID
  const handleFetchMobile = async () => {
    debugger;
    try {
      const response = await axios.get(
        `${API_BASE_URL}/Auth/Virtual_Get_Mobile_By_Login_ID/${loginId}`
      );

      if (response.status === 200) {
        setMobileNo(response.data.mobileNo);
        setUserName(response.data.username);
      }
    } catch (error) {
      alert("Invalid Login ID! Please enter a valid one.");
    }
  };

  // Send OTP
  const handleSendOtp = async () => {
    debugger;
    try {
      const response = await axios.post(
        `${API_BASE_URL}/Auth/Send_Otp_mobile?mobileno=${mobileNo}`
      );

      if (response.status === 200) {
        const parsedOtp = JSON.parse(response.data.mobile_otp).result;
        setOtp(parsedOtp.toString());
        setOtpSent(true);
        alert("OTP sent successfully!");
      }
    } catch (error) {
      alert("Failed to send OTP. Try again.");
    }
  };

  // Verify OTP
  const handleVerifyOtp = () => {
    if (enteredOtp === otp) {
      alert("OTP Verified Successfully!");
      captureFingerprint();
    } else {
      alert("Invalid OTP! Please try again.");
    }
  };

  const captureFingerprint = () => {
    setFingerprintScannerLoading(true);

    debugger;
    callSGIFPGetData((result) => {
      successFunc1(result);
      setFingerprintData(result.ISOTemplateBase64);
      const finger = result.ISOTemplateBase64;
      alert("Fingerprint captured successfully!");
      setFingerprintScannerLoading(false);
      handleUpdateThumb(finger);
    }, errorFunc);
  };

  const handleUpdateThumb = async (finger) => {
    debugger;
    if (!finger) {
      alert("Please scan your fingerprint first.");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/Auth/update_thumb`, {
        loginId,
        newThumb: finger,
        mobileNo,
      });

      if (response.status === 200) {
        setIsVerified(true);

        toast.success("Thumb updated successfully!");

        handleClose();
      }
    } catch (error) {
      alert("Failed to update thumb. Try again.");
    }
  };

  useEffect(() => {
    if (mobileNo) {
      handleSendOtp();
    }
  }, [mobileNo]);

  return (
    <>
      {fingerprintScannerLoading && <FingerprintScannerLoader />}
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 p-4">
        <div className="p-6 w-full max-w-md bg-white rounded-md shadow-md">
          <h2 className="text-xl font-semibold text-center mb-4">
            Update Thumb Request
          </h2>

          <div className="grid grid-cols-2 gap-4 text-black">
            {!otpSent && (
              <>
                <div className="col-span-2 flex justify-center">
                  <TextField
                    name="loginId"
                    label="Login ID"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={loginId}
                    onChange={(e) => setLoginId(e.target.value)}
                    required
                  />
                </div>

                <div className="col-span-1 flex justify-center">
                  <Button
                    variant="contained"
                    color="primary"
                    className="w-full bg-[#4F9CF9] text-white"
                    onClick={handleFetchMobile}
                  >
                    Update Thumb
                  </Button>
                </div>
              </>
            )}

            {otpSent && !isVerified && (
              <>
                <div className="flex flex-col gap-2 text-sm text-gray-600 w-full">
                  <p>
                    <strong>Login ID:</strong> {loginId}
                  </p>
                  <p>
                    <strong>Mobile No:</strong> {mobileNo}
                  </p>
                  <p>
                    <strong>Name:</strong> {userName}
                  </p>
                </div>

                {/* OTP Input Section */}
                <div className="col-span-2 flex items-center justify-center gap-4">
                  <p className="text-sm font-medium text-gray-600">
                    Enter OTP:
                  </p>

                  <div className="flex gap-2">
                    {Array.from({ length: 4 }).map((_, index) => (
                      <TextField
                        key={index}
                        id={`otp-input-${index}`}
                        variant="outlined"
                        size="small"
                        inputProps={{
                          maxLength: 1,
                          style: { textAlign: "center", fontSize: "1.5rem" },
                        }}
                        value={enteredOtp[index] || ""}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (!/^[0-9]?$/.test(value)) return;
                          const newOtp = enteredOtp.split("");
                          newOtp[index] = value;
                          setEnteredOtp(newOtp.join(""));
                          if (value && index < 3) {
                            document
                              .getElementById(`otp-input-${index + 1}`)
                              .focus();
                          }
                        }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            !enteredOtp[index] &&
                            index > 0
                          ) {
                            document
                              .getElementById(`otp-input-${index - 1}`)
                              .focus();
                          }
                        }}
                        style={{ width: "3rem" }}
                      />
                    ))}
                  </div>
                </div>

                <div className="col-span-2 flex justify-center">
                  <Button
                    variant="contained"
                    color="primary"
                    className="w-full bg-[#4F9CF9] text-white"
                    onClick={handleVerifyOtp}
                  >
                    Submit OTP
                  </Button>
                </div>
              </>
            )}

            {isVerified && (
              <>
                <div className="col-span-2 flex justify-center text-green-600 font-semibold">
                  Thumb updated Successfully! 🎉
                </div>
              </>
            )}

            <div className="col-span-1 flex justify-center">
              <Button
                variant="outlined"
                className="w-full text-[#DA0000] border border-[#DA0000]"
                onClick={handleClose}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateThumb;
